/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobHeapAnalysis {
    getFixupPrototypeFunction() { return BackgroundJobHeapAnalysis.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobHeapAnalysis>): BackgroundJobHeapAnalysis {
        let obj = Object.assign(new BackgroundJobHeapAnalysis(), model);
        BackgroundJobHeapAnalysis.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobHeapAnalysis>): BackgroundJobHeapAnalysis {
        if (!model) return null;
        return BackgroundJobHeapAnalysis.newInstance(<BackgroundJobHeapAnalysis> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobHeapAnalysis) {
        if (!obj) return;

        models.BackgroundJobHeapAnalysis.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobHeapAnalysis): boolean {
        Object.setPrototypeOf(obj, BackgroundJobHeapAnalysis.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.started_at === "string") {
            this.started_at = new Date(<string><any>this.started_at);
        }
        if (typeof this.completed_at === "string") {
            this.completed_at = new Date(<string><any>this.completed_at);
        }
        if (this.processes) {
            for (let val of this.processes) {
                models.BackgroundJobHeapAnalysisProcess.fixupPrototype(val);
            }
        }
    }

    /**
     * When the Background Job was created
     */
    started_at: Date;

    /**
     * When the Background Job was created
     */
    completed_at: Date;

    /**
     * Process data
     */
    processes: Array<models.BackgroundJobHeapAnalysisProcess>;

}
